import {InspectModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: InspectModel = {
  id: '',
  companiaId: '',
  clienteId: '',
  siteId: '',
  fechaEjecutada: '',
  fechaProgramacion: '',
  tipoAdministracion: '',
  tipoInspeccion: '',
  alcanceInspeccion: '',
  puntoId: '',
  proveedorId: '',
  codigoInspeccion: '',
  estado: '',
  porcentaje: '',
  cumpleEstandar: false,
  ...aditionalValues,
}
